import React from "react";

export default function Float(props) {
    let {style = {}, stretch = false} = props; 
    if(stretch){
        style.justifyContent = "stretch";
    }
    return (<div style={{...style}} className="ui-float">{props.children}</div>)
}